export default class Service {
  constructor() {
    this.callbacks = new Map();
    this.isInit = false;
  }

  get props() {
    throw new Error('The `props` getter must be implemented.');
  }

  init() {
    throw new Error('The `init` method must be implemented.');
  }

  kill() {
    throw new Error('The `kill` method must be implemented.');
  }

  add(key, callback) {
    if (this.has(key)) {
      throw new Error("A callback with the key `".concat(key, "` has already been registered."));
    }

    if (this.callbacks.size === 0 && !this.isInit) {
      this.init();
      this.isInit = true;
    }

    this.callbacks.set(key, callback);
    return this;
  }

  has(key) {
    return this.callbacks.has(key);
  }

  get(key) {
    return this.callbacks.get(key);
  }

  remove(key) {
    this.callbacks.delete(key);

    if (this.callbacks.size === 0 && this.isInit) {
      this.kill();
      this.isInit = false;
    }

    return this;
  }

  trigger() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this.callbacks.forEach(function forEachCallback(callback) {
      callback(...args);
    });
    return this;
  }

}